export const removeFormFieldStyles = {
	remover: {
		pointerEvents: 'auto',
		color: 'text.secondary',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		margin: 'auto',
		padding: 'auto',

		'&:hover': {
			color: 'text.primary',
			backgroundColor: 'var(--mui-palette-action-hover)'
		}
	},

	button: {
		fontWeight: 700
	},

	icon: {
		width: '15px',
		height: '15px'
	}
};
